import { h, Component } from 'preact';
import style from './index.less'

export default (props)=>{
    let classes = [style.expiry]
    props.class && classes.push(props.class)
    return (
        <div class={classes}>
            {props.expMonth}/{props.expYear}
        </div>
    )
}



// WEBPACK FOOTER //
// ./components/elements/CreditCardExpiry/index.js